import '../css/master.scss';

import '../css/components/navigation.scss';
import '../css/components/footer.scss';
import '../css/components/pairings.scss';
import '../css/components/transition.scss';
import '../css/components/toast.scss';
import '../css/components/contact.scss';

import '../css/pages/index.scss';
import '../css/pages/services.scss';
import '../css/pages/pricing.scss';
import '../css/pages/contact.scss';
import '../css/pages/about.scss';

import '../css/pages/service.scss';

import * as transition from './helpers/transition';
import * as scroll from './helpers/scroll';
import * as helper from './helpers';
import * as pricing from './helpers/pricing';
import * as contact from './helpers/contact';

import barba from '@barba/core';

barba.init({
  timeout: 7e3,
  sync: true,
  // If the hovered on link is unavailable, it is prevented from load and instead transitions to the 404 page.
  requestError: (trigger, action, url, response) => {
    if (response.status && response.status == 404) {
      if (!trigger.dataset.barbaPrevent) {
        trigger.dataset.barbaPrevent = '';

        helper.preventDefault(trigger, () => {
          barba.go('/404').then(() => {
            trigger.removeAttribute('data-barba-prevent')
          })
        })
      }
    }
  },
  transitions: [{
    /**
     * Hook at leave transition.
     * Also responsible for how long to wait till the page transitions in.
     */
    async leave() {
      const done = this.async();

      transition.start();
      await new Promise((done) => setTimeout(() => done(), 1000));
      
      done()
    },

    /**
     * Hook after everything has loaded.
     */
    async after(data) {
      initialize(data)
    },

    /**
     * Current page on its first load.
     */
    async once(data) {
      initialize(data, true)
    }
  }]
})

/**
 * Initializes core functions of the page using Barba.js data.
 * @param {Object} data barba.js provided data of current, next page and the trigger
 * @param {boolean} [once]
 */
function initialize(data, once) {
  // resets scroll position
  scroll.update(once);

	if (data.next.namespace == 'pricing') {
		pricing.initialize().then(() => repeatedFunctions(once))
	} else {
		repeatedFunctions(once)
	}

	if (data.next.namespace == 'contact') {
		contact.addContactListeners()
	}
}

/**
 * Refactored so that pages with loading requirements can be managed neatly.
 * @param {boolean} [once]
 */
function repeatedFunctions(once) {
	if (once) {
    scroll.disable();
    setTimeout(() => {
      transition.start(true)
    }, 500)

    helper.initializeToast()
  } else {
    transition.start(true)
  }
}